module.exports = "static/assets/78e3f697df85275aa8d384ca6fc0e288.svg";